import React, { useState } from 'react'
import { useHistory, Redirect } from 'react-router-dom'

function Header({ orderCount }) {
    const history = useHistory();
    const [close, SetClose] = useState(false);

    if (close) {
        return <Redirect to="/" />

    }

    const closeMe = () => {
        SetClose(true);
    }



    return (
        <header className="fixed header-blue">
            <div className="container">
                <div className="header-top">
                    <div className="header-top-left">
                        <span className="back"><img className="img-dark" src="/images/arrow-back.png" alt="" />
                            <img className="img-white" src="/images/arrow-back-white.png" alt="" onClick={closeMe} />
                        </span>
                    </div>
                    <div className="header-top-mid">
                        <span className="font-semibold">Placed Orders </span>
                        <span className="small">({orderCount} Orders)</span>
                    </div>
                    <div className="header-top-right"><a className="fa fa-times close text-white" onClick={closeMe}></a></div>
                </div>
            </div>
        </header>
    )
}

export default Header
